import {
	RecentTransactionsContainer,
	TagContainer,
} from '../../containers';

import {
	AppPage,
	MimaDateFilter,
	MimaFilter,
	MimaText,
	PageLoader,
	MimaDropdownFilter,
} from '../../components';
import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import TransactionInsightsCard from './TransactionInsightsCard';
import { userStore } from '../../stores';
import ExpenseViewMore from './ExpenseViewMore';
import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import IncomeViewMore from './IncomeViewMore';
import Survey from '../../components/Survey/Survey';

const Transactions = ({
	openExpensesModal,
	getExpensesModal,
	closeModal,
	loading,
	openIncome,
	getIncomeModal,
	summary,
	refresh,
	validationSchema,
	onSubmit,
	filterPeriod,
	resetFilter,
	viewMoreExpense,
	setViewMoreExpense,
	filterPeriods,
	getDate,
	openTagModal,
	setOpenTagModal,
	viewMoreIncome,
	setViewMoreIncome,
}) => {
	const [filteredTransactions, setFilteredTransactions] = useState([]);
	const [onReset, setOnReset] = useState(false);
	const [showSurvey, setShowSurvey] = useState(false);
	const permissions = new Set(
		toJS(userStore.user?.permissions?.map(perm => perm.name))
	);
	return (
		<AppPage pageTitle="Transaction" refresh={refresh}>
			<MimaText variant="subtitle" mb={2} align="center">
				You are viewing Transactions for {filterPeriod}
			</MimaText>
			{loading ? (
				<PageLoader title="Refreshing record..." loading={loading} />
			) : (
				<>
					<Formik
						initialValues={{
							startDate: '',
							endDate: '',
							period: '',
							periodText: '',
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<MimaFilter
								filterClick={() => {
									setOnReset(false);
									handleSubmit();
								}}
								loading={loading}
								resetClick={() => {
									setOnReset(true);
									resetFilter();
								}}>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<MimaDropdownFilter
										labelTitle="Filter period"
										placeholder="Select Period"
										variant="medium"
										name="period"
										data={filterPeriods}
										onChange={data => {
											const dates = getDate(data.key);
											setFieldValue('period', data.key);
											setFieldValue('startDate', dates.startDate);
											setFieldValue('endDate', dates.endDate);
											setFieldValue('periodText', data.value);
										}}
										error={errors.period}
										touched={touched.period}
									/>
									{values.period === 'custom' && (
										<div
											style={{
												display: 'flex',
												gap: '2rem',
												marginTop: '2rem',
											}}>
											<MimaDateFilter
												labelTitle="start date"
												name="startDate"
												value={!onReset ? values.startDate : ''}
												onChange={text => {
													setOnReset(false);
													setFieldValue('startDate', text);
												}}
												onBlur={handleBlur}
												width={18}
												touched={touched.startDate}
												error={errors.startDate}
											/>
											<MimaDateFilter
												labelTitle="End date"
												name="endDate"
												value={!onReset ? values.endDate : ''}
												onChange={text => {
													setOnReset(false);
													setFieldValue('endDate', text);
												}}
												onBlur={handleBlur}
												width={18}
												touched={touched.endDate}
												error={errors.endDate}
											/>
										</div>
									)}
								</div>
							</MimaFilter>
						)}
					</Formik>

					<div className={styles.main}>
						{permissions.has('CAN VIEW BUSINESS TRANSACTIONS SUMMARY') && (
							<TransactionInsightsCard
								summary={summary}
								filterPeriod={filterPeriod}
							/>
						)}

					</div>

					<RecentTransactionsContainer
						filteredTransactions={filteredTransactions}
						setFilteredTransactions={setFilteredTransactions}
						loading={loading}
						setViewMoreExpense={setViewMoreExpense}
						setViewMoreIncome={setViewMoreIncome}
						refresh={refresh}
						setOpenTagModal={setOpenTagModal}
					/>

					{(openExpensesModal ||
						openIncome ||
						viewMoreExpense ||
						openTagModal ||
						viewMoreIncome ||
						showSurvey) && (
						<div className="modal">
							<AnimatePresence>
								{viewMoreExpense && <ExpenseViewMore closeModal={closeModal} />}
								{openTagModal && (
									<TagContainer
										closeModal={closeModal}
										setShowSurvey={setShowSurvey}
									/>
								)}
								{viewMoreIncome && <IncomeViewMore closeModal={closeModal} />}
								{showSurvey && (
									<Survey
										title=""
										reviewId={userStore.reviewId}
										closeModal={() => {
											setShowSurvey(false);
										}}
									/>
								)}
							</AnimatePresence>
						</div>
					)}
				</>
			)}
		</AppPage>
	);
};

export default Transactions;
